// extracted by mini-css-extract-plugin
export var fullWidthButton = "_q7-0";